import { getTxHashfromMintId as getClaimerTxStatusfromMintId } from "@/services/network/claimer";
import { getTxHashfromMintId as getValidatorTxStatusfromMintId } from "@/services/network/validator";
import { useEffect, useState } from "react";
import useMintType from "./useMintType";
import { useTransaction } from "wagmi";
import { zksyncChainId } from "@/config/config";
import { useRef } from "react";

export default function useMintResult(mintId?: string) {
  const [txHash, setTxHash] = useState<string | undefined>(undefined);
  const { data, isLoading, isSuccess, error } = useTransaction({
    hash: txHash as any,
    chainId: zksyncChainId,
    cacheTime: 2000,
  });
  const timerRef = useRef<any>(null);

  const mintType = useMintType();

  useEffect(() => {
    if (!mintId) {
      setTxHash(undefined);
      return;
    }

    timerRef.current = setInterval(() => {
      const func =
        mintType === "validator"
          ? getValidatorTxStatusfromMintId
          : getClaimerTxStatusfromMintId;
      func({ mintId }).then((data) => {
        setTxHash(data.transactionHash);
        if (data.transactionHash) {
          clearInterval(timerRef.current);
        }
      });
    }, 3000);

    return () => {
      timerRef.current && clearInterval(timerRef.current);
    };
  }, [mintId, mintType]);

  return {
    data,
    error,
    isLoading,
    isSuccess,
    mintId,
  };
}
